<template>
  <div class="fillin">
     <div class="exam-result-wrap" >
          <div class="exam-cell" v-if='cur_data.chapter_content.quiz_type==7'>
               <!-- 段落填空-->
            <div class="cell-tit">
                <span>{{$t('fillInBlank3')}}</span>
                <audio-btn class="exam-audio"></audio-btn>
                <p v-html='$options.filters.filterFillin(cur_data.chapter_content.dry[0].content,cur_data.chapter_content.quiz_type,fillnum)' ></p>
                <!-- 图片查看 -->
                <div class="img-wrap" v-if="cur_data.file_path ? cur_data.file_path.length>0 : false">
                  <div v-for="(item, index) in cur_data.file_path" :key="index" class="img-list" @click="lookBgImg(item)">
                      <img :src="item"/>
                      <img src="@/assets/img/h5/img_fd.png" class="enlargement"/>
                  </div>
                </div>
            </div>
            <div class="cell-con">
                <div class="option">
                    <div  class="option-cell" :class="{isChose:option.isChose}"  v-for="(option ,i) in fillnum" :key="i">
                        <span>{{option}}</span><span><input type="text" :placeholder="$t('fillInAnswer')" v-model = cur_data.chapter_content.dry[0].answer[i]  :readonly='cur_data.answerShow'></span>
                    </div>
                </div>
                <div class="answer_fx" v-show="cur_data.answerShow">
                    <span>参</span>
                    <!-- <p>{{cur_data.chapter_content.dry[0].analysis}}</p> -->
                    <p v-html="cur_data.chapter_content.feedback.right"></p>
                </div>
            </div>
          </div>
          <div class="exam-cell"  v-else-if='cur_data.chapter_content.quiz_type==6'>
               <!-- 多行填空 -->
               <div class="cell-tit">
                   <span>{{$t('fillInBlank3')}}</span>
                   <audio-btn class="exam-audio"></audio-btn>
                   <p v-html="cur_data.chapter_content.quiz_title"></p>
                   <!-- 图片查看 -->
                    <div class="img-wrap" v-if="cur_data.file_path ? cur_data.file_path.length>0 : false">
                      <div v-for="(item, index) in cur_data.file_path" :key="index" class="img-list" @click="lookBgImg(item)">
                          <img :src="item"/>
                          <img src="@/assets/img/h5/img_fd.png" class="enlargement"/>
                      </div>
                    </div>
               </div>
               <div class="cell-con"  v-for='(item, index) in cur_data.chapter_content.dry' :key='item.id'>
                   <div class="multiple" >
                        <div class="tit">
                            {{item.content}}
                        </div>
                        <textarea name="" id="" v-model = item.answer :readonly='cur_data.answerShow'> </textarea>
                    </div>
                    <div class="answer_fx" v-show="cur_data.answerShow">
                        <span>参</span>
                        <p v-html="cur_data.chapter_content.dry[index].analysis"></p>
                    </div>
               </div>
          </div>
          <div class="exam-cell"  v-else>
               <!-- 问答题 -->
               <div class="cell-tit">
                   <span>{{$t('qustionAnswer2')}}</span>
                   <audio-btn class="exam-audio"></audio-btn>
                   <p v-html="cur_data.chapter_content.dry[0].content"></p>
                   <!-- 图片查看 -->
                    <div class="img-wrap" v-if="cur_data.file_path ? cur_data.file_path.length>0 : false">
                      <div v-for="(item, index) in cur_data.file_path" :key="index" class="img-list" @click="lookBgImg(item)">
                          <img :src="item"/>
                          <img src="@/assets/img/h5/img_fd.png" class="enlargement"/>
                      </div>
                    </div>
               </div>
               <div class="cell-con"  v-for='item in cur_data.chapter_content.dry' :key='item.id'>
                   <div class="multiple" >
                        <textarea name="" id="" v-model='cur_data.chapter_content.dry[0].answer' :readonly='cur_data.answerShow' class='wenda'> </textarea>
                    </div>
                    <div class="answer_fx analysis" v-show="cur_data.answerShow">
                        <h6>{{$t('questionParsing')}}:</h6>
                        <!-- <p>{{cur_data.chapter_content.dry[0].analysis}}</p> -->
                        <p v-html="cur_data.chapter_content.feedback.right"></p>
                    </div>
               </div>
          </div>

     </div>
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" >
            <v-bg-img :imgSrc="imgActive" v-if="imgActive" @closeImg="closeImg"></v-bg-img>
      </transition>
  </div>
</template>

<script>
import vBgImg from 'components/H5/bgImg.vue'
import mixins from 'components/H5/mixins/compon.js'
import audioBtn from 'components/H5/audioBtn'

export default {
  name: '',
  mixins: [mixins],
  data () {
    return {
      submitState: true,
      imgActive: null,
      fillnum: [] // 填空的空
    }
  },
  computed: {
    cur_data () {
      return this.$store.state.cur_data
    },
    next_data () {
      return this.$store.state.next_data
    }
  },
  created () {
    this.cur_data.chapter_content.dry[0].answer = [] // 段落填空添加答案数组
    this.getChapterAnswer()
  },
  mounted () {
    this.$nextTick(() => {
      $('.minitest').css('height', 'auto')
      $('.minitest').animate({ scrollTop: 0 }, 50)
      if ($('#appH5R')) {
        $('#appH5R').animate({ scrollTop: 0 }, 50)
      }
      let Height = $('body').height()
      $(window).resize(function () {
        $('body').height(Height)
      })
    })
    this.$store.commit('setAudioSrc', this.cur_data.audio_path || null)
    this.$store.commit('setAutoPlayer', !this.cur_data.answerShow)
  },
  methods: {
    submit () {
      for (let i = 0; i < this.cur_data.chapter_content.dry.length; i++) {
        let e = this.cur_data.chapter_content.dry[i]
        if (this.cur_data.chapter_content.quiz_type == 7) {
          // 段落填空
          let el = this.cur_data.chapter_content.dry[0].answer
          if (el.length != this.fillnum.length) {
            this.$layer.msg(this.$t('finishedSubmit'))
            return false
          }
          for (let il = 0; il < el.length; il++) {
            if (!el[i] || el[i].length == 0) {
              this.$layer.msg(this.$t('finishedSubmit'))
              return false
            }
          }
        } else {
          // 问答和多行填空
          if (!e.answer || e.answer.length == 0) {
            this.$layer.msg(this.$t('finishedSubmit'))
            return false
          }
        }
      }
      this.$set(this.cur_data, 'answerShow', true)
      this.$forceUpdate()
      this.setChaperAnswer()
      // console.log(this.cur_data);
    }
  },
  filters: {
    filterFillin (value, type, fillnum) {
      if (type == 7) {
        //         let value='复式的看计划{{n}}复合{{n}}大师看计划{{n}}复合大师{{n}}看计划{{n}}复合大师看计划' //測試用
        let m = 'A'
        var regs = value.match(/{{n}}*/g)
        for (let i = 0; i < regs.length; i++) {
          switch (i) {
            case 0: m = 'A'
              break
            case 1: m = 'B'
              break
            case 2: m = 'C'
              break
            case 3: m = 'D'
              break
            case 4: m = 'E'
              break
            case 5: m = 'F'
              break
            case 6: m = 'G'
              break
            case 7: m = 'H'
              break
          }
          value = value.replace(regs[i], '<span class="judge_tit">' + m + '</span>')
          fillnum[i] = m
          /* fillnum[i]={
              index:m,
              answer:''
              }; */
        }
        return value
      } else {
        return value
      }
    }
  },
  components: {
    vBgImg,
    audioBtn
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.fillin {
    font-size: .26rem;
    .exam-result-wrap {

    .exam-cell{
      width: 100%;
      min-height:1.9rem;
      background-color: #fff;
      color: #252631;
      box-sizing: border-box;
      padding: .3rem 0 .15rem;
      .cell-tit {
        font-size: .28rem;
        .img-wrap{
          margin-top: .3rem;
        }
        .exam-audio{
          display: inline-block;
        }
        span {
          display: inline-block;
          color: #005587;
          font-size: .24rem;
          vertical-align: top;
          &:nth-of-type(1){
            text-align: center;
            color: #005587;
            border-radius: 4px;
            border: .02rem solid #005587;
            position: relative;
            padding:.015rem .1rem;
            box-sizing: border-box;
            &:after {
              width: .1rem;
              height: .1rem;
              background: white;
              position: absolute;
              bottom: -.07rem;
              left: .2rem;
              content: "";
              z-index: 1;
              transform: rotate(45deg);
              border-right: .02rem solid #005587;
              border-bottom: .02rem solid #005587;
            }
          }
          &:nth-of-type(2){
            margin-left: .2rem;
          }
        }
       p {
           margin-top:.2rem;
       }
      }
      .cell-con {
        color: #252631;
        font-size:.28rem;
        padding-bottom: .25rem;
        .multiple {
            border: 1px solid #D9DDDE;
            border-radius: 3px ;
            margin-top:.3rem;
            .tit {
                padding: .2rem;
                color:@basic-color;
                background: #f6f6f6;
                min-height: .8rem;
                box-sizing: border-box;
            }
            textarea {
                display: inline-block;
                padding: .2rem;
                border:none;
                min-height: 1rem;
                width: 100%;
                font-family: "微软雅黑";
                font-size: .28rem;
                box-sizing: border-box;
                &.wenda {
                  min-height: 1.5rem;
                }
            }
        }

        .mini-img{
          position: relative;
          width: 1.2rem;
          height: 1rem;
          display: inline-block;
          margin-top: .3rem;
          img {
            position: absolute;
            display: inline-block;
            width: 1.2rem;
            height: 1rem;
            margin: 0 .2rem .2rem 0;
          }
          .fd {
            position: absolute;
            width: 1.2rem;
            height: 1rem;
            left: 0;
            top: 0;
            margin: 0 .2rem .2rem 0;
            background: url('../../../assets/img/h5/img_fd.png') no-repeat center;
            -webkit-background-size:50%;
            background-size:50%;
          }

        }
        .big-img {
          position: fixed;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index:10;
          background-color: rgba(0,0,0,.2);
          img {
            position: absolute;
            width: 100%;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        // p {
        //   overflow: hidden;
        //   text-overflow: ellipsis;
        //   /*!autoprefixer:off*/
        //   -webkit-line-clamp: 2;
        //   display:-webkit-box;
        //   // -webkit-box-orient:vertical;
        //   /*!autoprefixer:on*/
        // }
        .option {
        //   border-top:1px solid #D9DDDE;
          padding: .1rem 0  .3rem;
          margin-top: .3rem;
          .option-cell {
            width: 100%;
            min-height:1rem;
            border:1px solid #D9DDDE;
            position: relative;
            margin-top: .2rem;
            border-radius:.05rem;
            box-sizing: border-box;
            span {
              display: inline-block;
              vertical-align: middle;
              &:nth-of-type(2){
                color: #666;
                // padding: .3rem 0 0.3rem .2rem;
                width: 88%;
                font-size:.26rem;
                min-height:1rem;
                border-left:1px solid #D9DDDE;
                box-sizing: border-box;
                input {
                    display: inline-block;
                    box-sizing: border-box;
                    width: 100%;
                    height:1rem;
                    outline: none;
                    text-indent: 2em;
                    border:none;
                }
              }
              &:nth-of-type(1){
                text-align: center;
                font-weight: bold;
                width: 1rem;
                i {
                  display: inline-block;
                  width: .4rem;
                  height: .4rem;
                  border-radius:50%;
                  border:1px solid #D9DDDE;
                  position: absolute;
                  left: .3rem;
                  top: 50%;
                  margin-top: -.2rem;
                }
              }
            }
            &.right {
              border:3px solid rgba(74, 168, 84, 1);
              span {
                &:nth-of-type(1){
                  i {
                    background: url('../../../assets/img/h5/true.png') no-repeat center;
                  }
                }
                &:nth-of-type(2){
                  border-left:3px solid rgba(74, 168, 84, 1);
                }
              }
            }
            &.warning {
              border:3px solid #F75D5D;
              span {
                &:nth-of-type(1){
                  i {
                    background: url('../../../assets/img/h5/false.png') no-repeat center;
                  }
                }
                &:nth-of-type(2){
                  border-left:3px solid #F75D5D;
                }
              }
            }
            &.chose_true {
              span {
                &:nth-of-type(1){
                  i {
                    background: url('../../../assets/img/h5/choose-true.png') no-repeat center;
                  }
                }
              }
            }
            &.isChose {
              border:3px solid #005587;
              span {
                &:nth-of-type(1){
                  i {
                    background: url('../../../assets/img/h5/chose.png') no-repeat center / contain;
                    border:none;
                  }
                }
                &:nth-of-type(2){
                  border-left:3px solid #005587;
                }
              }
            }
          }
        }
        .option_wd {
          .option_a {
            width: 100%;
            background:rgba(247,247,247,1);
            border:1px solid rgba(217,221,222,1);
            font-size:.2rem;
            color: #666;
            padding: .2rem;
            margin: .2rem 0;
          }
          .option_e {
            border:1px solid #005587;
            width: 100%;
            height:auto;
            position: relative;
            border-radius: 3px;
            padding: .2rem;
            background-color: #EEF5FC;
            &:after{
              content: '';
              position: absolute;
              left: .4rem;
              top: -.11rem;
              width: .2rem;
              height: .2rem;
              -webkit-transform: rotate(45deg);
              transform: rotate(45deg);
              border:1px solid #005587;
              border-radius: 1px;
              background-color: #EEF5FC;
              border-right: none;
              border-bottom: none;
            }
            h6 {
              color: #005587;
              font-size:.24rem;
              font-weight: bold;
            }
          }
        }
        .option-e {
          margin-top: .3rem;
          font-size:.28rem;
          font-weight: bold;
          span {
            &.right {
              color: #252631;
            }
            &.false {
              color: #F75D5D;
            }

          }
          i {
            display: inline-block;
            &.false {
              color: #F75D5D;
            }
              &.right {
                color: #4AA854;
              }

            }
        }

      }
    }
  }
}
</style>
